<template>
<div>
  <el-table :data="merchantList">
    <el-table-column prop="userId" label="商户ID">
    </el-table-column>
    <el-table-column prop="name" label="名称">
    </el-table-column>
    <el-table-column label="创建时间">
      <template slot-scope="scope">
        <span>{{scope.row.createTime | moment}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="dealAmount" label="交易量">
    </el-table-column>
    <el-table-column prop="dealCount" label="交易笔数">
    </el-table-column>
    <el-table-column prop="rate" label="成交率">
      <template slot-scope="scope">
        {{scope.row.rate}}%
      </template>
    </el-table-column>
    <el-table-column label="在线状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__onlineStatus.color">
          {{scope.row.__onlineStatus.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="状态">
      <template slot-scope="scope">
        <el-tag :type="scope.row.__status.color">
          {{scope.row.__status.text}}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" fixed="right" width="150">
      <template slot-scope="scope">
        <el-button type="danger" @click="remove(scope.row.id)" size="small" v-if="scope.row.status === 1">
          删除
        </el-button>
        <el-button type="success" @click="reAdd(scope.row.userId)" size="small" v-if="scope.row.status === 0">
          添加
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <pagination :size="pagination.size" :page="pagination.page" :total="totalCount" @pageChanged="handleCurrentChange">
  </pagination>
</div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'merchantList',
  computed: {
    ...mapState('merchant', ['totalCount', 'pagination']),
    ...mapGetters('merchant', ['merchantList'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('merchant', ['removeMerchant']),
    remove(id) {
      this.$confirm('确定移除商户', '提示', {
        type: 'warning'
      }).then(() => {
        this.removeMerchant(id).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功！'
          });
          this.$emit('refresh');
        });
      });
    },
    reAdd(id) {
      this.$emit('reAdd', id);
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped>

</style>
